import styled from 'styled-components';

const presetColors = ({
  theme,
  selectedTheme = 'light',
  variant = 'primary'
}) => {
  const { button } = theme[selectedTheme];
  const { enabled, hover } = button[variant];

  return `
    color: ${enabled.color};
    background: ${enabled.background};
    border-color: ${enabled.borderColor};

    &:hover {
      color: ${hover.color};
      background: ${hover.background};
      border-color: ${hover.borderColor};

    }
  `;
};

const disabledStyles = ({ theme }) => `
    background: ${theme.carvana.gray.light};
    color: ${theme.carvana.gray.medium};
    pointer-events: none;
    cursor: default;
    border-color: transparent;
`;

export const defaultButtonStyles = props => `
  box-sizing: border-box;
  background: transparent;
  position: relative;
  margin: 0;
  padding: 0 20px;
  color: inherit;
  min-height: 56px;
  font-size: 16px;
  line-height: 16px;
  border-radius: 4px;
  min-width: 160px;
  font-weight: 500;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
  box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: 1px solid transparent;
  cursor: pointer;
  outline: none;
  user-select: none;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  appearance: none;
  font-family: ${props.theme.typography.fontFamily};

  &:focus { outline: none; }
`;

const buttonSize = ({ size = 'large' }) => `
    height: ${size === 'large' ? '56px' : '39px'}
  `;

export const conditionalStyles = props =>
  [props.disabled && disabledStyles(props)].filter(Boolean).join('');
export const DefaultButton = styled.button<{
  variant?: string;
  selectedTheme?: string;
  type?: string;
  disabled?: boolean;
  size?: string;
}>`
  ${defaultButtonStyles}
  ${presetColors}
  ${conditionalStyles}
  ${buttonSize}
`;
